export default [
  //COUNCIL PROFILE
  {
    path: '/parking-fee',
    name: 'parking-fee',
    component: () => import('@/views/parking-fee/Index.vue'),
    meta: {
      resource: 'parkingFee',
      action: 'read',
      pageTitle: 'Parking Fee',
      breadcrumb: [
        {
          text: 'Parking Fee',
          active: true
        }
      ],
    },
  }
]
